var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19625 2.1821C1.36882 1.84341 1.64419 1.56804 1.98288 1.39547C2.20991 1.27979 2.44584 1.237 2.68304 1.21762C2.90779 1.19926 3.18065 1.19927 3.49694 1.19928L6.25476 1.19925C6.49889 1.19902 6.71414 1.19882 6.92321 1.24901C7.10687 1.29311 7.28245 1.36584 7.4435 1.46453C7.62683 1.57687 7.77889 1.72921 7.95136 1.902L12.6054 6.55606C12.9469 6.89758 13.2288 7.17944 13.4396 7.42781C13.6586 7.68578 13.836 7.94681 13.937 8.25764C14.0936 8.73966 14.0936 9.2589 13.937 9.74092C13.836 10.0517 13.6586 10.3128 13.4396 10.5707C13.2288 10.8191 12.9469 11.101 12.6054 11.4425L11.2433 12.8046C10.9018 13.1461 10.6199 13.428 10.3715 13.6388C10.1136 13.8578 9.85253 14.0352 9.5417 14.1362C9.05968 14.2928 8.54044 14.2928 8.05842 14.1362C7.74759 14.0352 7.48656 13.8578 7.22859 13.6388C6.98023 13.428 6.69836 13.1461 6.35685 12.8046L1.70279 8.15058C1.52999 7.97811 1.37765 7.82604 1.26531 7.64272C1.16662 7.48167 1.09389 7.30609 1.0498 7.12242C0.999602 6.91336 0.999803 6.69811 1.00003 6.45397L1.00006 3.69615C1.00005 3.37986 1.00004 3.10701 1.0184 2.88226C1.03778 2.64506 1.08057 2.40912 1.19625 2.1821ZM5.20007 4.19922C4.53733 4.19922 4.00007 4.73648 4.00007 5.39922C4.00007 6.06196 4.53733 6.59922 5.20007 6.59922C5.86281 6.59922 6.40007 6.06196 6.40007 5.39922C6.40007 4.73648 5.86281 4.19922 5.20007 4.19922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelIcon);
export default __webpack_public_path__ + "static/media/label-icon.5dabafd94e9223c8ed2e4123e5fd1992.svg";
export { ForwardRef as ReactComponent };